<template>
  <div>&nbsp;</div>
  <div class="card">
    <div class="card-body">
      <div class="row mt-1">
        <assessment ref="rassessment" @setAssessment="changeAssesment($event)" />
      </div>
      <div class="row mt-5" v-if="v_assessment.Id != ''">
        <buildings ref="rbuildings" @setBuildings="setBuildings($event)" :method="v_assessment.Id"
          :idCliente="idCliente" :isAdmin="isAdmin" />
      </div>
      <div class="row mt-5" v-if="v_assessment.Id != '' && !isJVorDTS">
        <orientation ref="rorientation" @setOrientation="setOrientation($event)" :origin="'newQuote'" />
      </div>
      <div class="row mt-5" v-if="v_assessment.Id != ''">
        <direction ref="raddress" @setAddress="setAddress($event)" :method="v_assessment.Id" />
      </div>

      <div class="row mt-5" v-if="v_assessment.Id != '' && !isHB ">
        <div class="col-sm-12">
          <input class="form-check-input" type="checkbox" name="chkIncludeJs" id="chkIncludeJs" value="0"
            v-model="v_includeJs" />
          <label class="form-check-label modspec_font12" for="chkIncludeJs"> Include services assessments
            <span v-if="isJustV2622">Part 3.12.5</span>
            <span v-else-if="isJustH6V2">Parts 13.6 and 13.7</span>
            <span v-else-if="isNCC2019">J6 - J8</span>
            <span v-else>J7 - J9</span>
          </label>
        </div>
      </div>

      <div v-if="v_assessment.Id != ''">
        <div class="row mt-5">
          <div class="col-sm-12">
            Drawings (optional)
            <i @click="
              showInformation({ title: 'Information Required', body: 'Drawings' })
              " style="position: absolute; margin-top: -5px; cursor: pointer;"
              class="bi bi bi-info-circle me-1 modspec_font8" title="information required"></i>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
            <drop @setFiles="draggedFiles($event)" />
          </div>
        </div>
      </div>

      <div v-if="false" class="construction">
        <div class="row mt-5" v-if="v_assessment.Id != ''">
          <div class="col-sm-5">
            <div class="row">
              <div class="col-sm-12">
                Construction
                <div style="position: absolute; left: 120px; margin-top: -30px">
                  <i class="bi bi bi-info-circle me-1 modspec_font8" @click="
                    showInformation({
                      title: 'Construction',
                      body: 'Construction',
                    })
                    "></i>
                  <span class="modspec_font8">optional for discount</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-7" v-if="isLoggedIn">
            <input class="form-check-input" type="checkbox" id="gridCheck2" v-model="v_construction" />
            <label class="form-check-label modspec_font10" for="gridCheck2">
              Use construction details from previous job</label>
          </div>
        </div>

        <div class="row mt-3" v-if="v_assessment.Id != ''">
          <div class="col-sm-4"></div>
          <div class="col-sm-8" v-if="v_construction == false">
            <router-link class="btn btn-primary" :to="{ name: 'Construction', params: { id: idClient } }">Add
              construction to our system +</router-link>
          </div>

          <div class="col-sm-8" v-if="v_construction == true">
            <select class="form-select">
              <option value="">Select</option>
            </select>
          </div>
        </div>

        <div class="row mt-5" v-if="v_assessment.Id != '' && v_construction_id != null">
          <div class="col-sm-12 modspec_font10">
            <p class="modspec_font10-600">Nominated Construction Spec'</p>
            <p>Roof: sa 0.45, R1.3 blanket, C15019</p>
            <p>Ceiling: flat/raked, R2.5 Poly, Plasterboard 13mm or similar</p>
            <p>
              Walls: sa avg. 0.65 (Medium-dark), R0.2 TB to members/continuous,
              C15019 @ 450ctrs, plasterboard 13mm (or similar) lining.
            </p>
            <p>Glazing: All ext. glazing =&lt;U-val: 6.4 / =&lt;SHGC: 0.7</p>
            <p>
              Floor: Vinyl/carpet + 21mm plywood (or similar), Nil insulation,
              Enclosed perimeter skirt
            </p>
          </div>
        </div>

        <!---->
      </div>

      <div class="row mt-5" v-if="v_assessment.Id != ''">
        <div class="col-sm-12">
          <textarea type="text" style="width:100%;font-size:12px;" class="" v-model="v_notes" rows="5"
            placeholder="Add any additional notes you like to submit with this job for our consultants to take into consideration. Alternatively, email us at: commercial@modspec.com.au"></textarea>
        </div>
      </div>

      <div class="row mt-5" v-if="v_assessment.Id != '' && showSave == 1">
        <div class="col-sm-12 text-end">
          <button type="button" class="btn btn-primary" @click="saveNewQuote">
            ADD TO QUOTE
          </button>
        </div>
      </div>
    </div>
  </div>



  <infomodal ref="modalInformation" />


</template>
<script>
import nqassessment from "../../components/quote/nq-assessment.vue";
import buildings from "../../components/quote/nq-buildings.vue";
import orientation from "../../components/quote/nq-orientation.vue";
import address from "../../components/quote/nq-address.vue";
import info from "../../components/global/info-modal.vue";
import { isProxy, toRaw } from "vue";
import data from "../../helpers/data.json";

import drop from "../../components/quote/dropzone.vue";

export default {
  name: "new-quote", //new assessment ??
  props: ["idCliente", "showSave", "idUser", "isAdmin", "initialQuote"],
  components: {
    assessment: nqassessment,
    buildings: buildings,
    orientation: orientation,
    direction: address,
    infomodal: info,

    drop,
  },

  data: function () {
    return {
      v_name: "",
      v_assessment: { Id: "", Name: "" },
      v_buildings: [],
      v_orientation: { number: 0, orientations: '' },
      v_address: { ClimateZones: [], WeatherFiles: [] },
      v_construction: false,
      v_construction_id: null,
      v_notes: "",
      v_resume: "",
      v_includeJs: false,
      v_isLeadTime: false,

      idClient: 0,
      showClient: false,


      files: [],
      isSaving: false
    };
  },
  mounted() {
    if (this.initialQuote) this.loadFromQuote(this.initialQuote);
  },
  computed: {
    isLoggedIn() {
      let u = this.$vtc.getUsuarioLogueado();
      return u !== null;
    },
    isJVorDTS() {
      return this.$vtc.isJVorDTS(this.v_assessment.Id);
    },
    isHB() {
      return this.$vtc.isHB(this.v_assessment.Id);
    },
    isV2() {
      return this.$vtc.isV2(this.v_assessment.Id);
    },
    isNCC2019() {
      return this.$vtc.isNCC2019(this.v_assessment.Id);
    },
    isJustV2622(){
      return this.$vtc.isJustV2622(this.v_assessment.Id);
    },
    isJustH6V2() {
      return this.$vtc.isJustH6V2(this.v_assessment.Id);
    },
  },
  watch: {
    //v_construction: function () { this.calcQuote(); },
    v_includeJs(o, n) {
      console.log("VIENDO->", o, n)
      this.calcQuote();
    },
    initialQuote: {
      handler(quote) {
        if (quote) this.loadFromQuote(quote);
      },
      deep: true
    }
  },
  methods: {
    loadFromQuote(quote) {
      const serviceTypeId = quote.idServiceType || quote.IdServiceType;
      const assessment = data.serviceTypes.find(x => x.Id == parseInt(serviceTypeId));
      if (!assessment) return;

      this.v_name = quote.name || quote.Name || "";
      this.v_assessment = assessment;
      this.v_notes = quote.notes || quote.Notes || "";
      //this.v_resume = quote.resume || quote.Resume || "";
      this.v_includeJs = quote.includeAssessments || quote.IncludeAssessments || false;
      this.v_isLeadTime = quote.isLeadTime || quote.IsLeadTime || false;

      this.$emit("setMethod", this.v_assessment);

      this.$nextTick(() => {
        this.$refs.rassessment?.setAssessmentById(serviceTypeId);
        this.$refs.rbuildings?.setBuildingsValue(quote.buildings || quote.Buildings || []);
        this.$refs.rorientation?.setOrientationValue({
          number: quote.numOrientations || quote.NumOrientations || 0,
          orientations: quote.orientations || quote.Orientations || "",
        });
        this.$refs.raddress?.setAddressValue(quote);
        this.calcQuote();
      });
    },
    setResume(r) {
      this.v_resume = r;
    },
    setLeadTime(lt) {
      this.v_isLeadTime = lt;
      this.calcQuote();
    },
    setBuildings(ev) {
      this.v_buildings = ev;
      this.calcQuote();
    },
    setOrientation(ev) {
      this.v_orientation = ev;
      this.calcQuote();
    },
    setAddress(ev) {
      this.v_address = ev;
      this.calcQuote();
    },
    /*setIncludeJs(){
      this.v_includeJs = !this.v_includeJs;
      this.calcQuote();
    },*/
    changeAssesment(ev) {
      if (this.v_assessment.Id != "") {
        this.resetAll();
        this.$emit("setQuote", null);
      }

      this.v_assessment = ev;
      this.$emit("setMethod", this.v_assessment);
    },
    clientSaved(id) {
      this.idClient = id;
      this.showClient = false;
      this.saveNewQuote();
    },
    canCalculate() {
      let quote = this.getQuote();

      let qu = quote;
      let ican = true;

      if (this.v_assessment.Id == "") {
        ican = false;
      }
      if (this.v_buildings.length == 0) {
        ican = false;
      }
      if (!this.isJVorDTS && qu.NumOrientations == 0) {
        ican = false;
      }

      //----
      if ((qu.NumClimateZones == undefined && qu.NumWeatherFiles == undefined) || (qu.NumClimateZones <= 0 && qu.NumWeatherFiles <= 0)) {
        ican = false;
      }
      //----

      return ican;
    },
    ///////
    calcQuote() {
      let self = this;

      if (!this.canCalculate()) {
        self.$emit("setQuote", null);
        return false;
      }

      let qu = this.getQuote();
      this.$vtc.vtcFetch("/Assessment/Calculate", qu, 'API2').then(function (data) {
        qu.Price = data.total;
        qu.DataCalc = data;
        qu.TotalCrudeValue = data.totalCrudeValue;
        qu.TotalDiscount = data.totalDiscount;
        qu.TotalIncludeAssisment = data.totalIncludeAssisment;
        qu.TotalUrgentIncrementTime = data.totalUrgentIncrementTime;
        qu.PercentUrgentIncrementTime = data.percentUrgentIncrementTime;
        self.$emit("setQuote", qu);
      });
    },
    resetAll() {
      this.$refs.rbuildings.reset();
      if (!this.isJVorDTS) this.$refs.rorientation.reset();
      this.$refs.raddress.resetExtern(); ///-
      this.v_construction = false;
      this.v_notes = "";
      this.v_includeJs = false;
    },
    saveNewQuote() {
      let self = this;

      if (!this.canCalculate()) {
        return false;
      }

      let qu = this.getQuote();

      if (this.idClient == 0) {
        this.showClient = true;
        document.getElementById("btnOpenMdlSelectUser").click();
        return;
      }

      qu.UserId = this.idUser;//para q mvc lo revise
      let formData = new FormData();
      this.files.forEach(function (f) {
        formData.append("file[]", f);
      });
      formData.append("quote", JSON.stringify(qu));

      this.isSaving = true;
      this.$vtc.vtcFetch(`/Quote/SaveQuote`, formData).then(function () {
        document.getElementById("btnCloseMdlSelectUser").click();
        self.isSaving = false;
        self.$emit("savedQuote", qu);//reenviamos la info calculada
      });
    },
    
    //sirve para mandar a calcular
    getQuote() {
      
      if (this.idCliente !== null || this.idCliente !== undefined)
        this.idClient = this.idCliente;

      let usr = this.$vtc.getUsuarioLogueado();

      if (this.idClient == 0 && usr != null) {
        this.idClient = parseInt(usr.idClient);
      }

      let _address = this.v_address.address;
      let _numClimateZones = 0;
      let _climateZones = "";
      let _numWeatherFiles = 0;
      let _weatherFiles = "";

      _climateZones = this.v_address.ClimateZones.length > 0 ? this.v_address.ClimateZones.toString() : "";
      _weatherFiles = this.v_address.WeatherFiles.length > 0 ? this.v_address.WeatherFiles.toString() : "";

      _numClimateZones = this.v_address.NumClimateZones;
      _numWeatherFiles = this.v_address.NumWeatherFiles;

      let tQuote = {
        IdClient: this.idClient,
        IdServiceType: this.v_assessment.Id,
        Total: 0,
        Origin: "",
        Sent: false,
        Approved: false,
        Name: this.v_name,
        NumOrientations: this.v_orientation.number,
        Address: _address,
        NumClimateZones: _numClimateZones,
        ClimateZones: _climateZones,
        NumWeatherFiles: _numWeatherFiles,
        WeatherFiles: _weatherFiles,
        ConstructionDetails: this.v_construction,
        Notes: this.v_notes,
        Deleted: false,
        Resume: this.v_resume,
        IncludeAssessments: this.v_includeJs,
        IsLeadTime: this.v_isLeadTime,

        Price: 0,
        DataCalc: {},
        Buildings: [],
        NumBuildings: 0,
        NumBuildingsModules: 0,
        NumBuildingsName: "",
        NumBuildingsArea: "",
        className: "",
        WeatherFileName: this.v_address.WeatherFileName,
        ClimateZoneName: this.v_address.ClimateZoneName,
        Files: this.files,
        TotalCrudeValue: 0,
        TotalDiscount: 0,
        TotalIncludeAssisment: 0,
        TotalUrgentIncrementTime: 0,
        PercentUrgentIncrementTime: 0
      };

      let blds = this.v_buildings;
      if (isProxy(this.v_buildings)) {
        blds = toRaw(this.v_buildings);
      }

      this.v_buildings.forEach((build) => {
        console.log("build", build);
        if (typeof build.NumModules === "number") tQuote.NumBuildingsModules += parseInt(build.NumModules);
        if (build.Area != "") tQuote.NumBuildingsArea = build.Area;
      });

      if (this.v_buildings.length == 1)
        tQuote.NumBuildingsName = this.v_buildings[0].Name;

      if (this.v_buildings.length > 0) {
        tQuote.className =
          data.construction.find(
            (c) => c.value == this.v_buildings[0].BuildingClass
          )?.short_name || "";
      }

      tQuote.NumBuildings = blds.length;
      tQuote.Buildings = blds;

      return tQuote;
    },
    addConstruction() { },
    showInformation(info) {
      this.$refs.modalInformation.showInformation(info);
    },
    draggedFiles(files) {
      this.files = files;
      this.calcQuote();
    },
  },
};
</script>
<style scoped>
.form-control {
  font-size: 12px !important;
}
</style>
